import { render, staticRenderFns } from "./PlaceOfSaleCard.vue?vue&type=template&id=738bc9a8&scoped=true"
import script from "./PlaceOfSaleCard.vue?vue&type=script&lang=js"
export * from "./PlaceOfSaleCard.vue?vue&type=script&lang=js"
import style0 from "./PlaceOfSaleCard.vue?vue&type=style&index=0&id=738bc9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738bc9a8",
  null
  
)

export default component.exports